/**
 * 壳上的「联系客服」。号码/微信来自 GET /console/v1/support，未配则明示未开通。
 */
import { useState } from 'react';
import { Descriptions, Modal } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { getSupport } from '@/api/endpoints/system';
import { text } from '@/lib/format';

export function SupportEntry() {
  const [open, setOpen] = useState(false);
  const q = useQuery({
    queryKey: ['system', 'support'],
    queryFn: ({ signal }) => getSupport(signal),
    enabled: open,
    staleTime: 60_000,
    retry: false,
  });
  const d = q.data;
  const ready = Boolean(d?.phone || d?.wechat);

  return (
    <>
      <button type="button" onClick={() => setOpen(true)}>
        联系客服
      </button>
      <SupportDialog
        open={open}
        onClose={() => setOpen(false)}
        ready={ready}
        loading={q.isFetching}
        phone={d?.phone ?? null}
        wechat={d?.wechat ?? null}
        hours={d?.hours ?? null}
      />
    </>
  );
}

export function SupportDialog({
  open,
  onClose,
  ready,
  loading,
  phone,
  wechat,
  hours,
}: {
  open: boolean;
  onClose: () => void;
  ready: boolean;
  loading: boolean;
  phone: string | null;
  wechat: string | null;
  hours: string | null;
}) {
  return (
    <Modal title="联系客服" open={open} onCancel={onClose} footer={null} destroyOnHidden>
      {loading ? (
        <p>正在读取客服方式…</p>
      ) : !ready ? (
        <p>客服入口尚未开通。请通过客户经理联系，或等平台配置热线后再试。</p>
      ) : (
        <Descriptions column={1} size="small">
          {phone ? (
            <Descriptions.Item label="电话">
              <a href={`tel:${phone}`}>{phone}</a>
            </Descriptions.Item>
          ) : null}
          {wechat ? <Descriptions.Item label="微信">{wechat}</Descriptions.Item> : null}
          {hours ? <Descriptions.Item label="时间">{text(hours)}</Descriptions.Item> : null}
        </Descriptions>
      )}
    </Modal>
  );
}
